module.exports = __webpack_public_path__ + "img/logo.40c1c22c.png";